import EntryActions from 'actions/EntryActions';
import {Permissions} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import * as TaskRunner from 'util/TaskRunner';
import {OngoingTaskResponse} from 'util/TaskRunner';

import {Review} from './ReviewConstants';
import {isReviewUpdatedResponse, ReviewUpdatedResponse} from './ReviewDAO';
import {refreshFrozenChipVersion} from './ReviewUtil';

/**
 * To be called after a post request for a review action.
 *
 * This updates the Backbone store with the updated review to properly render the reviewable.
 */
export default async function postReviewActionServerUpdate(
  fileId: string,
  review: Review,
  permissions: Permissions,
  snapshotTask: OngoingTaskResponse | null,
  options: {refetch?: () => void} = {}
): Promise<void> {
  // If version chips is enabled, we want to refresh the entry so that the user is
  // on the right version
  if (BenchlingConfig.ENABLE_FROZEN_CHIPS) {
    await refreshFrozenChipVersion(fileId, review.status);
  } else {
    EntryActions.postServerUpdate(fileId, {review, permissions});
  }
  if (snapshotTask) {
    TaskRunner.resumeTask<ReviewUpdatedResponse>(snapshotTask.status_url).then((response) => {
      if (isReviewUpdatedResponse(response)) {
        const {review: updatedReview, filePermissions: updatedPermissions} = response;
        EntryActions.postServerUpdate(fileId, {review: updatedReview, permissions: updatedPermissions});
        options.refetch?.();
      }
    });
  }
}
